import {nanoid} from "nanoid";
import { CompassOutlined, FireOutlined, DollarOutlined } from '@ant-design/icons';

const stats = [
    {
        id: nanoid(),
        icon: <FireOutlined />,
        title: "Missions",
        value: "3 000"
    },
    {
        id: nanoid(),
        icon: <DollarOutlined />,
        title: "Paid to Delegate",
        value: "1 530"
    },
    {
        id: nanoid(),
        icon: <DollarOutlined />,
        title: "Paid to BTHERE",
        value: "300"
    },
    {
        id: nanoid(),
        icon: <CompassOutlined />,
        title: "CO2 Tons Saved",
        value: "302 095"
    },
];

export default stats;
